import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const ConfirmDiscardDialog = ({ open, onCancel, onConfirm }) => {
    return (
        <Dialog
            open={open}
            maxWidth="xs"
            fullWidth
            onClose={(event, reason) => {
                // Prevent closing via backdrop click or escape key
                // User must explicitly choose Keep editing or Close and discard
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                    return;
                }
                onCancel();
            }}
            disableEscapeKeyDown
        >
            <DialogTitle>
                Discard changes?
                <IconButton
                    onClick={onCancel}
                    style={{ position: 'absolute', right: 10, top: 12 }}
                    aria-label="close"
                    title="Close"
                >
                    <GridCloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Typography variant="body2">
                    You have unsaved changes. Are you sure you want to discard them?
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel} variant="contained" color="primary">
                    Keep editing
                </Button>
                <Button color="error" variant="contained" onClick={onConfirm}>
                    Close and discard
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDiscardDialog;